module.exports = __webpack_public_path__ + "fontello.svg?e187b32818fab654a78aca971bc15088";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-goodshare/src/fonts/fontello.svg?88483298
// module id = 14
// module chunks = 0